import React from 'react';
import { FormControlLabel, Typography } from '@mui/material';
import type { ISearchFilter } from '../../common-types';
import { StyledSwitch } from './BooleanFilters.style';
import { getFilterName } from '../__feature__';

type BooleanFilterProps = {
  filter: ISearchFilter;
  selectedOptions: string[];
  handleSelectedChange: (selectedOptions: string[]) => void;
  testId?: string;
};

export const BooleanFilter = ({
  filter,
  selectedOptions,
  handleSelectedChange,
  testId,
}: BooleanFilterProps) => {
  const handleChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    isChecked: boolean
  ) => {
    handleSelectedChange(isChecked ? ['true'] : []);
  };
  return (
    <FormControlLabel
      control={
        <StyledSwitch
          checked={selectedOptions.length > 0}
          onChange={handleChange}
        />
      }
      label={
        <Typography fontWeight={500}>
          {getFilterName(filter.filterName)}
        </Typography>
      }
      data-testid={testId}
    />
  );
};
